import React from 'react';

const FirebaseAuth = React.createContext(null);

export default FirebaseAuth;
